import { Vector as VectorLayer } from 'ol/layer'
import { Vector as VectorSource } from 'ol/source'
import { Feature } from 'ol'
import { Point } from 'ol/geom'
import { fromLonLat } from 'ol/proj'
import getPinStyle from '../getPinStyle'

export function createPinsLayer(pins: any) {
  const features = pins.map((pin: any) => {
    const feature = new Feature({
      geometry: new Point(fromLonLat([pin.lon, pin.lat])),
    })

    feature.setProperties({
      id: pin.id,
      type: pin.type,
      data: { lat: pin.lat, lon: pin.lon, ...pin.data },
    })

    feature.setStyle(getPinStyle(pin.type))
    // feature.setStyle(getPinStyle(pin.type, { selected: true }))

    return feature
  })

  const layer = new VectorLayer({
    source: new VectorSource({
      features,
    }),
  })

  layer.set('name', 'ENTITY_PINS')

  return layer
}
